import React from "react";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  // Handled by AuthLinkHandler in App.js; this is just a shell shown briefly.
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4">
      <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      <div className="text-sm text-muted-foreground font-mono">Completing sign-in…</div>
    </div>
  );
}
